import styled from 'styled-components'

export const Wrapper = styled.main`
  width: 293px;
  height: 240px;
  margin: 12px;
  box-shadow: 0px 1px 5px rgba(3, 5, 23, 0.05);

  .publisher {
    color: #bbbbbb;
    font-size: 12px;
    margin: 4px 12px;
  }
`

export const WrapperTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  .title,
  svg {
    margin: 12px 12px 0 12px;
  }

  .title {
    font-weight: bold;
  }

  svg {
    cursor: pointer;
  }
`
